import { useMutation, useQuery } from '@apollo/client/react';
import { Box, Center, Heading, HStack, Spinner, Text, VStack, Presence } from '@chakra-ui/react';
import { AppLayoutContextValue } from '@src/components/sco/AppLayout/AppLayoutContext';
import { REQUEST_BUILDER_GROUP_REQUEST_FRAGMENT } from '@src/components/sco/Requests/RequestBuilder/index';
import { RequestProfilePreview } from '@src/components/sco/Requests/RequestProfile/RequestProfilePreview';
import { GroupRequest, UpsertGroupRequestInput } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
import React from 'react';
export const RequestBuilderPreview: React.FC<{
  groupRequestId: string;
  requestsLayout?: AppLayoutContextValue;
}> = props => {
  const query = useQuery(gql`
      query ($groupRequestId: String!) {
        groupRequest(groupRequestId: $groupRequestId) {
          id
          groupRequestId
          ${REQUEST_BUILDER_GROUP_REQUEST_FRAGMENT}
        }
      }
    `, {
    variables: {
      groupRequestId: props.groupRequestId
    }
  });
  const [upsertGroupRequest, upsertGroupRequestMutation] = useMutation(gql`
    mutation ($input: UpsertGroupRequestInput!) {
      upsertGroupRequest(input: $input) {
        groupRequest {
          id
          groupRequestId
          ${REQUEST_BUILDER_GROUP_REQUEST_FRAGMENT}
        }
      }
    }
  `);
  const doRegenerate = () => {
    if (!groupRequest.groupRequestId) {
      alert('Cannot save, record not loaded yet.');
      return;
    }
    if (!upsertGroupRequestMutation.loading) {
      return upsertGroupRequest({
        variables: {
          input: {
            groupRequestId: groupRequest.groupRequestId,
            regenerateBody: true
          } as UpsertGroupRequestInput
        }
      });
    }
  };
  const groupRequest: GroupRequest = query.data?.groupRequest;
  if (query.loading && !groupRequest) {
    return <Center padding={4} width={'full'}>
        <Spinner />
      </Center>;
  }
  if (query.error) {
    return <Center padding={4} width={'full'}>
        <Text>Error: ${query.error.toString()}</Text>
      </Center>;
  }
  if (!groupRequest) {
    return <Center padding={4} width={'full'}>
        <Text>Not Loaded</Text>
      </Center>;
  }
  return <VStack align={'stretch'} gap={0} height={'full'} justify={'stretch'} width={'full'}>
      <HStack align={'center'} bgColor={'colorPalette.container/50'} height={'3.5rem'} justify={'space-between'} padding={3}>
        <HStack>
          <Heading size={'sm'}>Goal Preview</Heading>

          <Presence animationDuration={'moderate'} present={upsertGroupRequestMutation.loading} animationName={{
          _open: 'slide-from-bottom, fade-in',
          _closed: 'slide-to-bottom, fade-out'
        }}>
            <HStack>
              <Spinner />
              <Text fontSize={'xs'}>Updates saved, we'll re-generate!</Text>
            </HStack>
          </Presence>
        </HStack>

        {/* <HStack>
          <RequestEditModeToggle
            groupRequestId={groupRequest.groupRequestId}
            onRegenerate={() => doRegenerate()}
            isRegenerating={upsertGroupRequestMutation.loading}
          />
           <HStack justify={'flex-end'} width={'full'}>
            <PublishRequestButton groupRequestId={groupRequest.groupRequestId} size={'xs'} variant={'cta'} />
          </HStack>
         </HStack> */}
      </HStack>
      <VStack align={'center'} flex={1} justify={'start'} opacity={upsertGroupRequestMutation.loading ? '0.5' : 1} overflowY={'scroll'} padding={4} width={'full'} marginX={'auto'}
    // bgColor={'colorPalette.panel'}
    >
        <Box maxWidth={'container.lg'} width={'full'}>
          <RequestProfilePreview groupRequestId={groupRequest.groupRequestId} regenerateOnChange={() => doRegenerate()} show={{
          titleEditor: !groupRequest.bodyIsGenerated,
          bodyEditor: !groupRequest.bodyIsGenerated
        }} />
        </Box>
      </VStack>
    </VStack>;
};